import { AxiosResponse } from "axios"
import $api from "../../axios"
import { ICustomFilter } from "../../modules/sponsoredProducts/types/customFilter"

const filterApi = `/filter/`

export const ApiCustomFilter = (data) => {
  return $api
    .post<ICustomFilter, AxiosResponse<ICustomFilter>>(
      `${filterApi}getAllFilterWithOutPagination`,
      data
    )
    .then((res) => res.data)
    .catch((res) => res.data)
}
